import React from "react";
import { Fragment } from "react";
import Breadcrumb from "../components/Admin/Reusable/Breadcrumb";
import AggridTable from "../components/Admin/Reusable/AggridTable";
import ButtonColumn from "../components/Admin/Reusable/ButtonColumn";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import {
  fetchTestimonialsPagesList,
  fetchDeleteTestimonials,
} from "../actions/testimonials";
import { statusRender } from "../utils/cellRenderTable";
import { baseUrl } from "../utils";

const TestimonialsList = () => {
  const dispatch = useDispatch();

  const { dataPagesList } = useSelector((state) => state.testimonialsReducer);

  useEffect(() => {
    dispatch(fetchTestimonialsPagesList());
  }, [dispatch]);

  //akcija brisanja iz liste
  const handleSubmitModal = (pageId) => {
    dispatch(fetchDeleteTestimonials(pageId));
  };

  const imageRenderer = (params) => (
    <img
      src={baseUrl + "images/" + params.data.acImage}
      className="img-fluid image-preview-block-table"
      alt="UP IT"
    />
  );

  const customCellRenderer = (params) => (
    <ButtonColumn
      editLink={`/adminManager/testimonials-edit/` + params.data.anId}
      deleteItemId={params.data.anId}
      deleteItemTitle={params.data.acName}
      value={params}
      submitActionModal={handleSubmitModal}
    />
  );

  //settings za tabelu
  const columnDefs = [
    { headerName: "ID", field: "anId", filter: true, width: 100 },
    {
      headerName: "Slika",
      field: "acImage",
      cellRenderer: imageRenderer,
    },
    {
      headerName: "Naziv",
      field: "acName",
      filter: "agTextColumnFilter",
      flex: 1,
      minWidth: 250,
    },
    {
      headerName: "Jezik",
      field: "acLanguageName",
      filter: "agTextColumnFilter",
      width: 150,
    },
    {
      headerName: "Status",
      field: "acStatusName",
      filter: "agTextColumnFilter",
      cellRenderer: statusRender,
    },
    {
      headerName: "Kreirao",
      field: "ins_acUsername",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Izmenio",
      field: "edit_acUsername",
      filter: "agTextColumnFilter",
    },
    {
      headerName: "Datum kreiranja",
      field: "adTimeIns",
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Datum izmene",
      field: "adTimeEdit",
      filter: "agDateColumnFilter",
    },
    {
      headerName: "Panel",
      field: "custom",
      cellRenderer: customCellRenderer,
      pinned: "right",
      width: 120,
    },
  ];

  return (
    <Fragment>
      <Breadcrumb title="Pregled klijenata" type="testimonials-lista" />
      <AggridTable rowData={dataPagesList} columnDefs={columnDefs} />
    </Fragment>
  );
};

export default TestimonialsList;
